export enum NotificationType {
  GROUP_INVITATION = 'GROUP_INVITATION',
  SETTLEMENT_REQUEST = 'SETTLEMENT_REQUEST',
  SETTLEMENT_CONFIRMED = 'SETTLEMENT_CONFIRMED',
  SETTLEMENT_DECLINED = 'SETTLEMENT_DECLINED',
  SETTLEMENT_ROUND_STARTED = 'SETTLEMENT_ROUND_STARTED',
  EXPENSE_FLAGGED = 'EXPENSE_FLAGGED',
  MEMBER_JOINED = 'MEMBER_JOINED',
  MEMBER_LEFT = 'MEMBER_LEFT',
  MEMBER_REMOVED = 'MEMBER_REMOVED',
  INVITATION_DECLINED = 'INVITATION_DECLINED',
  SETTLEMENT_CATEGORY_CREATED = 'SETTLEMENT_CATEGORY_CREATED',
  RECURRENT_EXPENSE_CREATED = 'RECURRENT_EXPENSE_CREATED',
  RECURRENT_EXPENSE_CREATED_NO_AMOUNT = 'RECURRENT_EXPENSE_CREATED_NO_AMOUNT',
  RECURRENT_EXPENSE_UPCOMING = 'RECURRENT_EXPENSE_UPCOMING',
  RECURRENT_INCOME_CREATED = 'RECURRENT_INCOME_CREATED',
  RECURRENT_INCOME_CREATED_NO_AMOUNT = 'RECURRENT_INCOME_CREATED_NO_AMOUNT',
  RECURRENT_INCOME_UPCOMING = 'RECURRENT_INCOME_UPCOMING',
  DEPOSIT_INTEREST_CREATED = 'DEPOSIT_INTEREST_CREATED',
  DEPOSIT_MATURED = 'DEPOSIT_MATURED',
  CREDIT_STATEMENT = 'CREDIT_STATEMENT',
  TEST_NOTIFICATION = 'TEST_NOTIFICATION',
  INVESTMENT_PAYMENT_UPCOMING = 'INVESTMENT_PAYMENT_UPCOMING',
  INVESTMENT_INCOME_CREATED = 'INVESTMENT_INCOME_CREATED',
  INVESTMENT_CATEGORY_REQUIRED = 'INVESTMENT_CATEGORY_REQUIRED',
  INVESTMENT_DUPLICATE_REVIEW = 'INVESTMENT_DUPLICATE_REVIEW',
  // a per-account portfolio drawdown watch fired: total unrealized return dropped to its target %
  PORTFOLIO_DRAWDOWN = 'PORTFOLIO_DRAWDOWN',
  BOT_ORDER = 'BOT_ORDER',
  BOT_LOW_BALANCE = 'BOT_LOW_BALANCE',
  BOT_INSUFFICIENT_FUNDS = 'BOT_INSUFFICIENT_FUNDS',
  BOT_API_ERROR = 'BOT_API_ERROR',
  // day-trade bot auto-disabled an instrument on start because the account already held lots
  // bought outside the bot and no user was present to decide whether to adopt them
  BOT_HELD_OUTSIDE = 'BOT_HELD_OUTSIDE',
  QUICK_EXPENSE_NO_DESCRIPTION = 'QUICK_EXPENSE_NO_DESCRIPTION',
}

// notification types delivered in-app only: never pushed to Telegram and hidden from the per-type
// Telegram preference screen. used when the user triggered the action from Telegram itself (e.g. a
// quick expense from a plain-number message), so a Telegram echo would be redundant — and the
// follow-up (filling the description) is easier in the app anyway.
export const IN_APP_ONLY_NOTIFICATION_TYPES: ReadonlySet<NotificationType> = new Set([
  NotificationType.QUICK_EXPENSE_NO_DESCRIPTION,
])
